module.exports = __webpack_public_path__ + "static/media/signup-instruction-mobile.a61fef98.png";